import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ICompra, IVenta } from '../../models/IRegistros';
import { LCV_MOCK_COMPRAS_PAGE } from '../../mocks/lcv-table-mock';
import { LcvApiService } from '../../services/lcv-api.service';
import { catchError, map, take } from 'rxjs/operators';
import { Subscription, forkJoin, of } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { SessionService } from 'src/app/shared/services/session.service';
import { MatPaginator } from '@angular/material/paginator';
import { Store } from '@ngrx/store';
import { IUserInfoCognito } from 'src/app/shared/services/cognito.service';
import { selectUserInfo } from 'src/app/state/selectors/userInfo.selectors';
import { selectSelectedOrganization } from 'src/app/state/selectors/selectedOrganization.selectors';

@Component({
  selector: 'app-lcv-proveedores-table',
  templateUrl: './lcv-proveedores-table.component.html',
  styleUrls: ['./lcv-proveedores-table.component.scss']
})
export class LcvProveedoresTableComponent implements OnChanges, OnInit{
  @Input() selectedToggle: string = '';
  @Input() periodoInicial = 2024; 
  @Input() meses = '';
  @Input() public cantidadRegistrosVenta: number = 0;
  @Input() public cantidadRegistrosCompra: number = 0;
  @ViewChild('paginator') paginator: MatPaginator | null = null;

  public paginaActual: any[] = [];
  
  public currentItem = 10;
  public tipoPagina: string = 'compra';
  
  public currentPage = 1;
  public cantidadPaginas: number = 0;
  public cantidadRegistros: number = 0;
  public paginasActualesErrores: {pagina: number, error: string}[] = []
  public paginasActuales: {pagina: number, response: any}[] = [];
  public paginationOptions: number[] = [10, 25, 50, 100];

  public isLoadingTable: boolean = true;

  public userInfo: IUserInfoCognito | null = null;
  private _userInfo$: Observable<IUserInfoCognito> = this.store.select(selectUserInfo);

  public selectedOrganization: string | null = this._sessionService.getOrganization();
  private _selectedOrganization$ = this.store.select(selectSelectedOrganization);
  private _orgSubscription: Subscription | undefined;

  constructor(
    private _apiService: LcvApiService,
    private toastr: ToastrService,
    private _sessionService: SessionService,
    private store: Store
    ) {
  }

  ngOnInit(): void {    
    this.selectedOrganization = this._sessionService.getOrganization();
    this._orgSubscription = this._selectedOrganization$.subscribe((selectedOrg)=> {
      this.selectedOrganization = selectedOrg;
    })
  }
  
  ngOnChanges(changes: SimpleChanges) {
    this._userInfo$.pipe(take(1)).subscribe((userInfo) => {
      this.userInfo = userInfo;
    })
    this.obtenerCantidadPaginas(true);
    this.resetTable();
  }

  resetTable() {
    if(this.paginator) {
      this.paginator.firstPage();
    }
  }

  cambioPaginacion(value: string){
    this.currentItem = Number(value);
    this.obtenerCantidadPaginas(true);
  }

  //Object { previousPageIndex: 1, pageIndex: 2, pageSize: 10, length: 100 
  onPageChange(event: any) {
    this.getPage(event.pageIndex + 1);
  }

  obtenerCantidadPaginas(forzar: boolean = false): void {
    if(this.seeVentas() && this.cantidadRegistrosVenta > 0) {
      this.cantidadRegistros = this.cantidadRegistrosVenta;
      this.cantidadPaginas = Math.ceil(this.cantidadRegistrosVenta / this.currentItem);
    }
    else if(this.seeCompras() && this.cantidadRegistrosCompra > 0) {
      this.cantidadRegistros = this.cantidadRegistrosCompra;
      this.cantidadPaginas = Math.ceil(this.cantidadRegistrosCompra / this.currentItem);
    }
    if(this.cantidadPaginas > 0) {
      this.getPage(1, forzar);
    } else {
      this.isLoadingTable = false;
    }
  }

  getPage(event: number, forzar: boolean = false): void {
    this.paginasActualesErrores = [];
    if((this.seeCompras && this.cantidadRegistrosCompra > 0) || (this.seeVentas && this.cantidadRegistrosVenta > 0) || forzar) {
      const tipoActual: string = this.seeVentas() ? 'venta' : (this.seeCompras() ? 'compra' : '');
      const elemento: any = this.paginasActuales.find(e => e.pagina == (event))

      if((this.tipoPagina != tipoActual || elemento == undefined || forzar)){
        this.isLoadingTable = true;
        if(this.tipoPagina != tipoActual || forzar){
          this.paginasActuales = [];
        }

        if(event == 1){
          const paginas: number[] = [];
          for(let i = 0; i < 3; i++){
            const pagina = event + i;
            if(pagina > 0 && pagina <= this.cantidadPaginas){
              paginas.push(pagina);
            }
          }
          this.obtenerPaginas(paginas, event);
          this.tipoPagina = tipoActual
        } else if(event > 1 && event <= this.cantidadPaginas) {
          const pagina: number = event;
          const paginas: number[] = [pagina - 1, pagina];
          if(event + 1 <= this.cantidadPaginas)
            paginas.push(pagina + 1);
          this.obtenerPaginas(paginas, event);
          this.tipoPagina = tipoActual
        } 
      } else {
        this.paginaActual = elemento?.response || [undefined];
      }
    }

    this.currentPage = event;
  }

  obtenerPaginas(paginas:  number[], paginaActual: number): void {
    this.isLoadingTable = true;
    const tipo: string = this.seeVentas() ? 'VENTA' : (this.seeCompras() ? 'COMPRA' : '');
    const apiServices: any = [];
    if(this.cantidadPaginas > 0 && paginas.length > 0 && tipo) {
      paginas.forEach(pagina => {
        if(pagina > 0 && pagina <= this.cantidadPaginas && !this.paginasActuales.some(e => e?.pagina == pagina)) {

          apiServices.push(
            {
              service: this.getServicePagina(pagina, this.currentItem, tipo),
              pagina: pagina
            }
          );

        }
      });

      // se quitan elementos que no se desean consultar
      this.paginasActuales = this.paginasActuales.filter(item =>
        paginas.includes(item.pagina) && 
        item.pagina > 0 && 
        item.pagina <= this.cantidadPaginas
      );

    }
    if(apiServices.length > 0) {
      this.isLoadingTable = true;
      this.llamadaObtenerPaginas(apiServices, paginaActual);
    }
  }

  getServicePagina(pagina: number, cantidadElementos: number, tipo: string): any {
    console.log(this.selectedOrganization);
    if(!this.userInfo || !this.selectedOrganization) return
    let currentRut = this.selectedOrganization;
    let currentUser = this.userInfo.username;
    return this._apiService.obtenerPagina(currentUser, currentRut, pagina, cantidadElementos, tipo, this.meses, this.periodoInicial)
      .pipe(
        map(resp => {
          this.setResponse(resp, pagina);
        })
      )
      .pipe(
        catchError((error) => (this.setError(pagina, error?.error?.message || 'Error Inesperado en servicio'), of(null))));
  }

  setResponse(response: any[], pagina: number): void {
    this.paginasActuales.push({
      pagina: pagina,
      response: response || null
    });
  }

  setError(pagina: number, error: string): void {
    this.paginasActualesErrores.push({
      pagina: pagina,
      error: error
    })
  }

  llamadaObtenerPaginas(apiServices: any[], paginaActual: number): void {
    const services = apiServices.map(e => e?.service);

    forkJoin(services).subscribe(
      resp => {
        if(this.paginasActualesErrores.length > 0) { // valida si hay errores y si estan repetidos para mostrarlos
          const mensajesMostrados: Set<string> = new Set();
      
          this.paginasActualesErrores.forEach(e => {
            const mensaje: string = e?.error || 'Ha ocurrido con una de las paginas consultadas';
            if (!mensajesMostrados.has(mensaje)) {
              this.toastr.error('', mensaje);
              mensajesMostrados.add(mensaje);
            }
          });
        }

        const elemento: any = this.paginasActuales.find(e => e.pagina == (paginaActual))
        this.paginaActual = elemento?.response || [undefined];
        this.isLoadingTable = false;
      },
      error => {
        this.toastr.error('',error.message || 'Ocurrió un error al consultar por las paginas');
        this.isLoadingTable = false;
      }
    );
  }

  seeVentas() {
    return this.selectedToggle == 'VENTA';
  }

  seeCompras() {
    return this.selectedToggle == 'COMPRA';
  }

  // TODO!: llevar formateadores a un servicio aparte
  esFormatoFecha(cadena: string | undefined): boolean {
    if (typeof cadena !== 'string' || !cadena) {
      return false;
    }

    const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
    return regex.test(cadena);
  }

  cambiarFormatoFecha(cadena: string | undefined): any {
    if(!cadena) return ""
    if (!this.esFormatoFecha(cadena)) {
      return cadena;
    }
    
    return cadena.replace(/\//g, "-");
  }

  esFormatoFechaHora(cadena: string | undefined): boolean {
    if (typeof cadena !== 'string' || !cadena) {
      return false;
    }

    const regex = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/;
    return regex.test(cadena);
  }

  cambiarFormatoFechaHora(cadena: string | undefined): any {
    if(!cadena) return ""
    if (!this.esFormatoFechaHora(cadena)) {
      return cadena;
    }
    
    return cadena.replace(/\//g, "-");
  }

}
